export default __webpack_public_path__ + "static/media/Banner - AirLockz - Black.875e0167.jpg";